export class SentryLoggerConfig {
  dsn: string;
  environment: string;
}
